export default function setCompanies(companies, company) {
  if (company && companies.indexOf(company.company) === -1) {
    companies.push(company.company)
  }
  return companies
}



// WEBPACK FOOTER //
// ./src/modules/user/helpers/setCompanies.js